import type { IFilter } from "../../../../types/models/filter.models.types";
import { usePostHttp } from "../../http.hook";
import type { IFavoriteSocial } from "./get-all-favorites.admin.http";

interface IBody {
  favouriteSocial: string;
  filter:IFilter;
}

export function useAddNewFavoriteWithFiltersAdminHttp() {
  return usePostHttp<IBody, IFavoriteSocial>({
    path: "/admin/favourite-socials/filter",
  });
}
